import { RestClient } from '../network';
import { ConnectLinksDTO } from './types/ConnectLinksDTO';

const sessionApi = {
  fetchUrl: (): Promise<ConnectLinksDTO> => new RestClient('/login', 'GET', 'application/json').execute(),
};
export default sessionApi;
